import { ScheduleService } from "../fhir/ScheduleService";
import { ActorModel } from "../fhir/fhir.types";
import { ActorCalendar } from "./Scheduling.types";
import {
  mapScheduleSummary,
  mapUnlinkedAppointmentsCalendar,
} from "./scheduling.mappers";

export class ActorCalendarService {
  constructor(private readonly scheduleService: ScheduleService) {}

  async getForActors(actors: ActorModel[]): Promise<ActorCalendar> {
    if (actors.length === 0) {
      return { actors: [], schedules: [] };
    }

    const sortedActors = [...actors].sort((left, right) =>
      left.display.localeCompare(right.display),
    );
    const actorOrder = new Map(
      sortedActors.map((actor, index) => [actor.reference, index]),
    );
    const schedules = await this.scheduleService.searchByActors(sortedActors);
    const realSchedules = schedules.map(mapScheduleSummary);
    const virtualCalendars = sortedActors.map(mapUnlinkedAppointmentsCalendar);

    return {
      actors: sortedActors,
      schedules: [...realSchedules, ...virtualCalendars].sort((left, right) => {
        const actorDifference =
          (actorOrder.get(left.actorReference) ?? Number.MAX_SAFE_INTEGER) -
          (actorOrder.get(right.actorReference) ?? Number.MAX_SAFE_INTEGER);
        if (actorDifference !== 0) {
          return actorDifference;
        }
        if (left.kind !== right.kind) {
          return left.kind === "schedule" ? -1 : 1;
        }
        return (left.subtitle || left.title).localeCompare(
          right.subtitle || right.title,
        );
      }),
    };
  }
}
